import { SVGProps } from 'react'

export const DotFrameIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={32}
		height={32}
		viewBox="0 0 32 32"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<rect
			x={6}
			y={6}
			width={20}
			height={20}
			rx={10}
			stroke="currentColor"
			strokeWidth={3}
		/>
	</svg>
)

export const SquareFrameIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={36}
		height={32}
		viewBox="0 0 36 32"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path stroke="currentColor" strokeWidth={3} d="M8 6h20v20H8z" />
	</svg>
)

export const ExtraRoundedFrameIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={32}
		height={32}
		viewBox="0 0 32 32"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<rect
			x={6}
			y={6}
			width={20}
			height={20}
			rx={6}
			stroke="currentColor"
			strokeWidth={3}
		/>
	</svg>
)

export const DotDotIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={28}
		height={28}
		viewBox="0 0 28 28"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<circle cx={14} cy={14} r={7.5} fill="currentColor" />
	</svg>
)

export const SquareDotIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={28}
		height={28}
		viewBox="0 0 28 28"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<rect x="6.5" y="6.5" width="15" height="15" fill="currentColor" />
	</svg>
)
